module.exports = __webpack_public_path__ + "img/page.755f0326.svg";